import styled from 'styled-components';

const TextField = styled.input`
    height: 2rem;
    width: 30%;
    font-Size: 20px;
    font-wieght: bold;
    border-radius: 5px;
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 600;
`;

const Div = styled.div`
    display: flex;
    flex-direction: column;
`;

const Flex = styled.div`
    display: flex;
    gap: 10px;
`;

export {TextField, Span, Div, Flex};